import { makeStyles, mergeClasses } from '@fluentui/react-components';
import logoUrl from './legends-logo-white.svg';

const useStyles = makeStyles({
  img: { display: 'block', width: 'auto' },
  // The source artwork is white; the light skin shows it in black.
  onLight: { filter: 'brightness(0)' },
});

export function LegendsLogo({
  tone,
  height = 44,
  className,
}: {
  tone: 'onDark' | 'onLight';
  height?: number;
  className?: string;
}) {
  const styles = useStyles();
  return (
    <img
      src={logoUrl}
      alt="Legends Global"
      height={height}
      className={mergeClasses(styles.img, tone === 'onLight' && styles.onLight, className)}
    />
  );
}
